
#easmDashboardContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: calc(var(--spacer) * 10);
  width: 100%;
  cursor: default;
  position: relative;

  .widget-section {
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    gap: var(--spacer);
    width: 50%;

    &.error-section {
      justify-content: center;

      .btn-wrapper {
        display: flex;
        gap: var(--spacer);
      }
    }

    gz-button,
    gz-tooltip {
      margin: auto;
    }
  }

  .pr-1 {
    cursor: pointer;
    border-radius: 50px;
    padding-right: calc(1 * var(--spacer));
    padding-left: calc(1 * var(--spacer));
  }

  #icon-scan-configuration {
    border: 1px solid var(--body-text-arrows-400);
  }

  #icon-scan-now {
    border: 1px solid var(--blue-layout-400-primary);
    &:hover {
      background: var(--blue-layout-305-active) !important;
      border-color: var(--blue-layout-301-active);
      svg {
        fill: var(--blue-layout-301-active) !important;
      }
    }
  }
}

@media screen and (max-width: 1537px) {
  .section-title {
    font-size: 12px !important;
  }
}
